import React from 'react'
import PropTypes from 'prop-types'
import FooterCompany from '../FooterCompany'
import FooterLinks from '../FooterLinks'
import { footerSiteLinks } from '../../setup/stubs'

const Footer = ({ locations = [], socialLinks = {} }) => {
  const footerLinks = footerSiteLinks
  const locationsLink = footerLinks.find(({ locations }) => locations)
  if (locationsLink)
    locationsLink.links = locations.map((location) => ({
      label: location.shortName,
      external: true,
      href: `/locations/${location.slug}`
    }))

  return (
    <footer>
      <FooterLinks sections={footerLinks} />
      <FooterCompany socialLinks={socialLinks} />
    </footer>
  )
}

Footer.propTypes = {
  locations: PropTypes.array,
  socialLinks: PropTypes.object
}

export default Footer
